import { BASE_URL } from 'config';
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router components
import { useLocation, useNavigate } from "react-router-dom";

// Custom hooks
import { useAuth } from "hooks/useAuth";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
// (تمت إزالة استيراد Avatar المكرر)

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Typography from "@mui/material/Typography";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const route = useLocation().pathname.split("/").slice(1);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const routeTitles = {
    users: "المستخدمين",
    dashboard: "الرئيسية",
    attributes: "السمات",
    attributes_values: "قيم السمات",
    merchants: "التجار",
    stores: "المتاجر",
    categories: "الفئات",
    brands: " الماركات ",
    products: " المنتجات ",
    storeDocumntation: " وثائق المتاجر ",
    LocationTypes: "تصنيفات المواقع",
    locations: "المواقع",
    currency: "العملات",
    customer_address: "مواقع العملاء",
    payment_methods: "طرق الدفع",
    payment_configs: "اعدادات طرق الدفع",
    shipping_methods: "طرق الشحن",
    shipping_configs: "اعدادات طرق الشحن",
    shipping_pricing: "اسعار شركات الشحن",
    wallets: "المحافظ الالكترونية",
    customer_wallets: "محافظ  العملاء",
    store_wallets: "محافظ المتاجر",
    overview: "عمليات المحافظ الالكترونية",
    operations: "عمليات المحافظ",
  };

  const [userData, setUserData] = useState(null);

  // نافذة الإشعارات المنبثقة
  const [openNotifications, setOpenNotifications] = useState(false);
  const handleOpenNotifications = () => setOpenNotifications(true);
  const handleCloseNotifications = () => setOpenNotifications(false);

  // بيانات إشعارات ثابتة مبدئياً
  const staticNotifications = [
    {
      id: 1,
      icon: <NotificationsIcon color="error" />,
      title: "طلب جديد رقم 1234",
      description: "تم استلام طلب جديد من العميل أحمد.",
      date: "منذ دقيقة واحدة",
    },
    {
      id: 2,
      icon: <NotificationsIcon color="error" />,
      title: "تم تحديث حالة الطلب",
      description: "تم شحن الطلب رقم 1233.",
      date: "منذ 10 دقائق",
    },
    {
      id: 3,
      icon: <NotificationsIcon color="error" />,
      title: "تنبيه مهم",
      description: "حدثت مشكلة في الدفع لطلب رقم 1222.",
      date: "منذ ساعة",
    },
    {
      id: 4,
      icon: <NotificationsIcon color="error" />,
      title: "طلب جديد رقم 1235",
      description: "تم استلام طلب جديد من العميلة سارة.",
      date: "منذ 3 دقائق",
    },
    {
      id: 5,
      icon: <NotificationsIcon color="error" />,
      title: "تم تحديث حالة الطلب",
      description: "تم تسليم الطلب رقم 1231.",
      date: "منذ 15 دقيقة",
    },
    {
      id: 6,
      icon: <NotificationsIcon color="error" />,
      title: "تنبيه مهم",
      description: "تم إلغاء الطلب رقم 1229.",
      date: "منذ ساعتين",
    },
    {
      id: 7,
      icon: <NotificationsIcon color="error" />,
      title: "طلب جديد رقم 1236",
      description: "تم استلام طلب جديد من العميل محمد.",
      date: "منذ 5 دقائق",
    },
    {
      id: 8,
      icon: <NotificationsIcon color="error" />,
      title: "تم تحديث حالة الطلب",
      description: "تم تجهيز الطلب رقم 1230 للشحن.",
      date: "منذ 20 دقيقة",
    },
    {
      id: 9,
      icon: <NotificationsIcon color="error" />,
      title: "تنبيه مهم",
      description: "هناك مشكلة في عنوان التوصيل للطلب رقم 1228.",
      date: "منذ 3 ساعات",
    },
    {
      id: 10,
      icon: <NotificationsIcon color="error" />,
      title: "طلب جديد رقم 1237",
      description: "تم استلام طلب جديد من العميلة ليلى.",
      date: "منذ 7 دقائق",
    },
  ];

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  useEffect(() => {
    // جلب بيانات المستخدم
    const fetchUserData = async () => {
      const userId = localStorage.getItem("user-id");
      const token = localStorage.getItem("user-token");
      if (!userId || !token) return;
      try {
        const res = await fetch(
          `${BASE_URL}/administrator/users/show/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await res.json();
        if (data && data.data) setUserData(data.data);
      } catch (e) {
        setUserData(null);
      }
    };
    fetchUserData();
  }, []);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Logout handler
  const handleLogout = () => {
    logout();
    navigate("/authentication/sign-in", { replace: true });
  };

  // دالة جلب وتحويل محفظة الأدمن
  const handleAdminWalletClick = async () => {
    try {
      const token = localStorage.getItem("user-token");
      const response = await fetch(BASE_URL + "/administrator/wallets", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.data && data.data.length > 0) {
        const adminWallet = data.data[0];
        navigate(`/operations/${adminWallet.id}`);
      }
    } catch (error) {
      // يمكنك إضافة إشعار خطأ هنا إذا رغبت
    }
  };


  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs
            icon="home"
            title={routeTitles[route[route.length - 1]] || route[route.length - 1]}
            route={route}
            light={light}
          />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/* أيقونة المحفظة */}
            <IconButton
              sx={navbarIconButton}
              size="small"
              disableRipple
              color="inherit"
              onClick={handleAdminWalletClick}
              title="محفظة الأدمن"
            >
              <AccountBalanceWalletIcon sx={iconsStyle} />
            </IconButton>
            {/* صورة واسم المستخدم */}
            <MDBox display="flex" alignItems="center" ml={2} mr={1}>
              {userData && userData.avatar ? (
                <Avatar
                  src={`https://back.al-balad.sa/uploads/users/avatars/${userData.avatar}`}
                  alt={userData.name}
                  sx={{ width: 32, height: 32, ml: 1 }}
                />
              ) : (
                <Avatar sx={{ width: 32, height: 32, ml: 1 }}>
                  <Icon>account_circle</Icon>
                </Avatar>
              )}
              <MDTypography variant="button" color="text" fontWeight="bold">
                {userData ? userData.name : ""}
              </MDTypography>
            </MDBox>
            {/* باقي الأزرار */}
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarMobileMenu}
              onClick={handleMiniSidenav}
            >
              <Icon sx={iconsStyle} fontSize="medium">
                {miniSidenav ? "menu_open" : "menu"}
              </Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              onClick={handleConfiguratorOpen}
            >
              <Icon sx={iconsStyle}>settings</Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              aria-controls="notification-menu"
              aria-haspopup="true"
              variant="contained"
              onClick={handleOpenNotifications}
            >
              <Icon sx={iconsStyle}>notifications</Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              onClick={handleLogout}
              title="تسجيل الخروج"
            >
              <Icon sx={iconsStyle}>logout</Icon>
            </IconButton>
            {/* نافذة الإشعارات المنبثقة */}
            <Dialog
              open={openNotifications}
              onClose={handleCloseNotifications}
              maxWidth="xs"
              fullWidth
              PaperProps={{
                sx: { borderRadius: 4, p: 0, overflow: "hidden" },
              }}
            >
              <DialogTitle
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  bgcolor: "#f5f5f5",
                  borderBottom: "1px solid #eee",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <NotificationsIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    الإشعارات
                  </Typography>
                </span>
                <IconButton aria-label="إغلاق" onClick={handleCloseNotifications} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ p: 0 }}>
                <List sx={{ width: "100%", bgcolor: "background.paper", px: 2, py: 1 }}>
                  {staticNotifications.length === 0 ? (
                    <ListItem>
                      <ListItemText primary="لا توجد إشعارات حالياً" />
                    </ListItem>
                  ) : (
                    staticNotifications.map((notif) => (
                      <ListItem
                        key={notif.id}
                        alignItems="flex-start"
                        sx={{ borderBottom: "1px solid #f0f0f0", pr: 0 }}
                      >
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: "white", mr: 1 }}>{notif.icon}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Typography fontWeight="bold">{notif.title}</Typography>}
                          secondary={
                            <>
                              <Typography variant="body2" color="text.secondary">
                                {notif.description}
                              </Typography>
                              <Typography variant="caption" color="text.disabled" display="block">
                                {notif.date}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    ))
                  )}
                </List>
              </DialogContent>
            </Dialog>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
